import dayjs from "dayjs";

export const formatDate = (date) => dayjs(date).format("DD.MM.YYYY");

export const formatDateIso8601 = (date) => dayjs(date).format("YYYY-MM-DD");

export const formatDateHourMinute = (date) =>
  dayjs(date).format("DD.MM.YYYY HH:mm");
